// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Content084_wrapper__xz_hd","block":"Content084_block__g6yPr","tabs":"Content084_tabs__o2nFD","title":"Content084_title__Y_ezT"};